module.exports = __webpack_public_path__ + "img/instagram.a930ef7f.svg";